"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphaFunctions = void 0;
var alphabet = require("../constants/alpha.json");
exports.alphaFunctions = {
    lowercaseAt: function (i) {
        return alphabet.LOWERCASE[i];
    },
    uppercaseAt: function (i) {
        return alphabet.UPPERCASE[i];
    },
    lowercaseVowelAt: function (i) {
        return alphabet.LOWERCASE_VOWELS[i];
    },
    uppercaseVowelAt: function (i) {
        return alphabet.UPPERCASE_VOWELS[i];
    },
    lowercaseNonVowelAt: function (i) {
        return alphabet.LOWERCASE_NON_VOWELS[i];
    },
    uppercaseNonVowelAt: function (i) {
        return alphabet.UPPERCASE_NON_VOWELS[i];
    },
};
//# sourceMappingURL=alpha.js.map